/* globals angular */

(function () {
  var module = angular.module('ace.helperService', []);

  module.factory('HelperService', [
    '$rootScope',
    '$q',
    '$http',
    '$sce',
    '$filter',
    'appConfig',
    function HelperService($rootScope, $q, $http, $sce, $filter, appConfig) {
      var service = {};

      $rootScope.$helper = service;

      service.thumbnailSrc = function (
        thumbnail,
        settings,
        cropSlug,
        cropDefault
      ) {
        if (!thumbnail) {
          return '';
        }

        var settingsArray;

        if (typeof settings === 'string') {
          settingsArray = settings.split(/,|;/);

          settings = {};

          settingsArray.forEach(function (setting) {
            setting = setting.split(/_|:/);

            settings[setting[0]] = setting[1];
          });
        }

        var crop = thumbnail.crops ? thumbnail.crops[cropSlug] : false;

        if (crop) {
          settings.x = crop[0];
          settings.y = crop[1];
          settings.x2 = crop[2];
          settings.y2 = crop[3];
        } else if (cropDefault) {
          settings.g = cropDefault;
        }

        settingsArray = [];

        angular.forEach(settings, function (value, key) {
          settingsArray.push([key, value].join(':'));
        });

        var settingsString = settingsArray.join(';');

        if (/(image)/.test(thumbnail.type)) {
          if (thumbnail.ext === 'svg') {
            return [
              appConfig.assistUrl,
              appConfig.slug,
              thumbnail.name + thumbnail.ext,
            ].join('/');
          }

          return [
            appConfig.assistUrl,
            appConfig.slug,
            'transform',
            settingsString,
            thumbnail.name + thumbnail.ext,
          ].join('/');
        }

        if (/(video)/.test(thumbnail.type)) {
          return [
            appConfig.assistUrl,
            appConfig.slug,
            'transform',
            settingsString,
            thumbnail.name,
            'thumb.jpg',
          ].join('/');
        }

        if (/(oembed|proxy)/.test(thumbnail.type)) {
          var url = thumbnail.url.replace(/https?:\/\//, '');

          return [
            appConfig.assistUrl,
            appConfig.slug,
            'proxy',
            'transform',
            settingsString,
            url,
          ].join('/');
        }

        return '';
      };

      service.videoSrc = function (video, settings) {
        if (!video) {
          return '';
        }

        var settingsArray;

        if (typeof settings === 'string') {
          settingsArray = settings.split(/,|;/);

          settings = {};

          settingsArray.forEach(function (setting) {
            setting = setting.split(/_|:/);

            settings[setting[0]] = setting[1];
          });
        }

        settingsArray = [];

        angular.forEach(settings, function (value, key) {
          settingsArray.push([key, value].join(':'));
        });

        var settingsString = settingsArray.join(';');

        return [
          appConfig.assistUrl,
          appConfig.slug,
          'transform',
          settingsString,
          video.name + video.ext,
        ].join('/');
      };

      service.oembedThumbnailUrl = function (oembedField, settings) {
        if (!oembedField) {
          return '';
        }

        return service.proxyThumbnailUrl(
          oembedField.oembed.thumbnail_url,
          settings
        );
      };

      service.proxyThumbnailUrl = function (url, settings) {
        return service.thumbnailSrc(
          {
            type: 'proxy',
            url: url,
          },
          settings
        );
      };

      service.attachmentUrl = function (field, options) {
        options = options || {};
        if (!field) {
          return '';
        }
        return [
          appConfig.assistUrl,
          appConfig.slug,
          'file',
          options.download ? 'download' : 'view',
          field.file.name + field.file.ext,
          field.original.fileName,
        ].join('/');
      };

      var focus = function (entity, focusType) {
        return $q(function (resolve, reject) {
          if (!entity) {
            reject('Entity invalid');
            return;
          }

          var thumbnail = entity.thumbnail || entity;

          if (!thumbnail.fileName) {
            reject('No filename found');
            return;
          }

          var fileName = thumbnail.fileName;

          $http
            .get(
              appConfig.assistUrl +
                '/' +
                appConfig.slug +
                '/image/focus-' +
                focusType +
                '?fileName=' +
                fileName
            )
            .then(function (response) {
              resolve(response.data);
            })
            .catch(reject);
        });
      };

      service.focusPoint = function (entity) {
        return focus(entity, 'point');
      };

      service.focusRegion = function (entity) {
        return focus(entity, 'region');
      };

      service.imageRatio = function (image) {
        if (!image) {
          return 0;
        }
        return image.metadata.width / image.metadata.height;
      };

      service.shuffle = function (a) {
        for (
          var j, x, i = a.length;
          i;
          j = Math.floor(Math.random() * i), x = a[--i], a[i] = a[j], a[j] = x
        ) {
          //
        }
        return a;
      };

      service.randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      };

      service.randomIntInclusive = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      };

      service.group = function (entities, groupSize) {
        groupSize = groupSize || Infinity;

        var grouped = [];
        var group = {
          entities: [],
        };

        entities.forEach(function (entity) {
          if (!entity.groupBefore || group.entities.length >= groupSize) {
            group = {
              entities: [],
            };
          }

          group.entities.push(entity);

          if (!entity.groupAfter || group.entities.length >= groupSize) {
            group.ratio = 0;

            group.entities.forEach(function (entity) {
              group.ratio += (entity.thumbnail || entity).ratio;
            });

            group.entities.forEach(function (entity) {
              entity.groupRatio =
                (entity.thumbnail || entity).ratio / group.ratio;
            });

            grouped.push(group);
          }
        });

        return grouped;
      };

      service.assignGroupIndex = function (entities) {
        var groupIndex = 0;

        entities.forEach(function (entity) {
          entity.groupIndex = groupIndex;

          if (!entity.groupAfter) {
            groupIndex++;
          }
        });

        return entities;
      };

      var _taxonomyFlatten = function (taxonomy, attr, prefix, depth) {
        prefix = prefix || '';
        depth = depth || 0;

        var terms = [];

        if (!taxonomy) {
          return terms;
        }

        if (taxonomy.terms) {
          taxonomy.terms.forEach(function (term) {
            terms.push(term[attr]);
            if (term.parents) {
              term.parents.forEach(function (parent, i) {
                if (i < depth) {
                  terms.push(parent[attr]);
                }
              });
            }
          });
        }

        terms = terms.filter(function (term, i, self) {
          return self.indexOf(term) === i;
        });

        terms = terms.map(function (term) {
          return prefix + term;
        });

        return terms;
      };

      service.taxonomyFlattenTitle = function (taxonomy, prefix, depth) {
        return _taxonomyFlatten(taxonomy, 'title', prefix, depth);
      };

      service.taxonomyFlattenSlug = function (taxonomy, prefix, depth) {
        return _taxonomyFlatten(taxonomy, 'slug', prefix, depth);
      };

      service.altGroup = function (input, altFactor, groupLengths) {
        altFactor = altFactor || 3;
        groupLengths = groupLengths || [2, 1, 2];

        var grouped = [];
        var group = [];
        var rowLength = groupLengths[0];

        input.forEach(function (item, i) {
          group.push(item);

          if (group.length === rowLength || i === input.length - 1) {
            grouped.push(group);

            rowLength = groupLengths[grouped.length % altFactor];

            group = [];
          }
        });

        return grouped;
      };

      service.testExp = function (exp, str) {
        return new RegExp(exp).test(str);
      };

      service.getAdjacent = function (collection, current, prop) {
        prop = prop || 'slug';

        var adjacent = {};

        collection.forEach(function (item, i) {
          if (current[prop] === item[prop]) {
            adjacent.current = current;
            adjacent.next =
              i === 0 ? collection[collection.length - 1] : collection[i - 1];
            adjacent.previous =
              i === collection.length - 1 ? collection[0] : collection[i + 1];
          }
        });

        return adjacent;
      };

      service.trustAsHtml = function (html, filters) {
        if (!html) {
          return '';
        }

        if (filters) {
          if (angular.isArray(filters)) {
            filters.forEach(function (filter) {
              html = $filter(filter)(html);
            });
          }
        }

        return $sce.trustAsHtml(html);
      };

      service.videoStyle = function (
        slideWidth,
        slideHeight,
        videoWidth,
        videoHeight
      ) {
        var w;
        var h;

        if (slideWidth / slideHeight > videoWidth / videoHeight) {
          h = slideHeight;
          w = h * (videoWidth / videoHeight);
        } else {
          w = slideWidth;
          h = w * (videoHeight / videoWidth);
        }

        return {
          width: w + 'px',
          height: h + 'px',
        };
      };

      return service;
    },
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/@homerjam/ace-angular/services/HelperService.js
// module id = 57
// module chunks = 0